import * as React from 'react';

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField';

import { ValidateDate, ValidateDateRange, ValidateString, ValidateTime } from '../utils/Validator.tsx';

export default function CharismaCourseForm(props){
    
    const [subject, setSubject] = React.useState(props.subject);
    const [nError, setNError] = React.useState(0);
    const [lateDate, setLateDate] = React.useState(props.lateDate);
    const [lateHour, setLateHour] = React.useState(props.lateHour);
    const [dError, setDError] = React.useState(0);
    const [hError, setHError] = React.useState(0);
    const [wait, setWait] = React.useState(false);
    
    function handleSubmit(){
        
        const lValidName: boolean = ValidateString(subject, 1024);
        if(!lValidName){
            setNError(1);
        }
        
        let lValidMin: number = ValidateDate(lateDate);
        setDError(lValidMin);

        
        let lValidMax : number = ValidateTime(lateHour);
        setHError(lValidMax);
        
        
        
        if(lValidMax === 0 && lValidMin === 0 && props.lateId === undefined ){
            props.handleSubmit(lateDate, lateHour, subject);
        }
        if(lValidMax === 0 && lValidMin === 0 && props.lateId !== undefined){
            props.handleSubmit(lateDate, lateHour, subject, props.lateId);
        }

        
    }
    
    return(
        <Dialog
            open={true}
        >
            <DialogTitle>
                {
                    props.title
                }
            </DialogTitle>
            <DialogContent>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="subject"
                    label="Motif"
                    name="subject"
                    InputLabelProps={{ shrink: true, required: true }}
                    error={nError > 0}
                    helperText={nError === 1 ? 'Motif invalide' : null }
                    value={subject}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setSubject(event.target.value);
                    }}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="lateDate"
                    label="Date"
                    name="lateDate"
                    InputLabelProps={{ shrink: true, required: true }}
                    type={'date'}                    
                    error={dError > 0}
                    helperText={dError === 1 ? 'Date invalide' : null }
                    value={lateDate}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setLateDate(event.target.value);
                    }}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="toDate"
                    label={props.type === 0 ? "Heure d'arrivée" : "Heure de départ"}
                    name="lateHour"
                    InputLabelProps={{ shrink: true, required: true }}
                    type={'time'}
                    error={hError > 0}
                    helperText={hError === 1 ? 'Heure invalide' : null}               
                    value={lateHour}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setLateHour(event.target.value);
                    }}
                />             
                

                {wait ?
                    <Alert severity='info'>{props.id === undefined ? "Création en cours" : "Modification en cours"}</Alert>
                    :
                    null
                }
            </DialogContent>
            <DialogActions>
                <Button disabled={wait} onClick={()=>handleSubmit()}>Valider</Button>
                <Button disabled={wait} onClick={()=>props.handleCancel()}>Annuler</Button>
            </DialogActions>
        </Dialog>        
    );
}